import { render, staticRenderFns } from "./PatentPlanMining.vue?vue&type=template&id=61aed86a&scoped=true&"
import script from "./PatentPlanMining.vue?vue&type=script&lang=js&"
export * from "./PatentPlanMining.vue?vue&type=script&lang=js&"
import style0 from "./PatentPlanMining.vue?vue&type=style&index=0&id=61aed86a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aed86a",
  null
  
)

export default component.exports